import { useState, useCallback } from 'react';

interface UseFormResetReturn {
    needReset: boolean;
    triggerReset: () => void;
    onResetComplete: () => void;
}

export const useFormReset = (): UseFormResetReturn => {
    const [needReset, setNeedReset] = useState(false);

    const triggerReset = useCallback(() => {
        setNeedReset(true);
    }, []);

    const onResetComplete = useCallback(() => {
        setNeedReset(false);
    }, []);

    return { needReset, triggerReset, onResetComplete };
};
